import { OmniHeroesCommunity } from "@/types"

// 设置语言
export const SET_LANGUAGE = {
    type: 'SET_LANGUAGE',
    language: ''
}

// 设置用户
export const SET_USERINFO: {
    type: string,
    userInfo?: {
        id: string | number,
        name: string
    } | null
} = {
    type: 'SET_USERINFO',
    userInfo: null
}

export const LOG_OUT: {
    type: string
} = {
    type: 'LOG_OUT'
}

export const SET_USER_INFO: {
    type: string,
    userInfo?: OmniHeroesCommunity.UserInfo
} = {
    type: 'SET_USER_INFO',
    userInfo: undefined
}
 

// 所有用户的Actions
export type USER_ACTION = typeof SET_LANGUAGE | typeof SET_USERINFO | typeof LOG_OUT | typeof SET_USER_INFO 